import '@popperjs/core';
import * as bootstrap from 'bootstrap';

// Make bootstrap available globally
window.bootstrap = bootstrap;

document.addEventListener('DOMContentLoaded', function() {
    // Inicializar todos los tooltips de Bootstrap
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });
    
    // Función global para actualizar contador de notificaciones
    window.updateNotificationCount = function(count) {
        const notificationBtn = document.querySelector('.notification-btn');
        const badge = notificationBtn.querySelector('.notification-badge');
        
        if (count > 0) {
            notificationBtn.classList.add('has-notifications');
            
            if (badge) {
                badge.textContent = count > 99 ? '99+' : count;
            } else {
                // Crear badge si no existe
                const newBadge = document.createElement('span');
                newBadge.className = 'position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger notification-badge';
                newBadge.textContent = count > 99 ? '99+' : count;
                notificationBtn.appendChild(newBadge);
            }
        } else {
            notificationBtn.classList.remove('has-notifications');
            if (badge) {
                badge.remove();
            }
        }
        
        // Actualizar tooltip
        const tooltip = bootstrap.Tooltip.getInstance(notificationBtn);
        if (tooltip) {
            const newTitle = count > 0 
                ? `${count} notificación${count > 1 ? 'es' : ''} no leída${count > 1 ? 's' : ''}`
                : 'Notificaciones';
            notificationBtn.setAttribute('title', newTitle);
            tooltip.setContent({ '.tooltip-inner': newTitle });
        }
    };

    // Funcionalidad de filtros (código existente)
    const applyFiltersBtn = document.getElementById('applyFilters');
    const filtersForm = document.getElementById('filtersForm');
    
    if (applyFiltersBtn && filtersForm) {
        applyFiltersBtn.addEventListener('click', function() {
            filtersForm.submit();
        });
    }
});
